export const openInNewTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
